
<template>
    <div>
        <label>
            Full name
            <input class="input" v-model="address.fullname" type="text"/>
        </label>

        <label>
            Address 1
            <input class="input" v-model="address.line1" type="text"/>
        </label>

        <label>
            Address 2
            <input class="input" v-model="address.line2" type="text"/>
        </label>

        <label>
            City
            <input class="input" v-model="address.city" type="text"/>
        </label>

        <label>
            County
            <input class="input" v-model="address.county" type="text"/>
        </label>

        <div class="columns">
            <label class="column">
                Postcode
                <input class="input" v-model="address.postcode" type="text"/>
            </label>

            <label class="column">
                Country
                <input v-if="country" class="input" :value="country.name" type="text" readonly/>
                <select v-else class="select" v-model="address.country">
                    <option v-for="country in countries" :value="country.code">{{ country.name }}</option>
                </select>
            </label>
        </div>

    </div>
</template>

<script>
    import countries from '../support/countries'
    import Address from '../models/Address';

	export default
    {
		data()
        {
        	const country = countries.find( data => data.code === this.countryCode );

        	return {
		        country,
		        countries,
            };
        },
        props:
        {
	        address: {
		        //default: new Address,
		        type: Address,
                required: true,
	        },
	        countryCode: {
	        	type: String,
            }
        },
	};
</script>
